import { render, staticRenderFns } from "./Fabs.vue?vue&type=template&id=f856162c"
import script from "./Fabs.vue?vue&type=script&lang=js"
export * from "./Fabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports